// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Input,
    InputLabel,
    Select
} from "@mui/material";

// App Imports
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {changeUsers} from "./usersSlice";
import {addUsers, editUsers} from "./UsersClient";
import {getAllDataPoints} from "../DataPoint/DataPointClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";

// Main Function
export default function UsersDrawer({usersDrawerState,usersDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);
    const [departmentDropdown, setDepartmentDropdown] = useState([]);
    const [roleDropdown, setRoleDropdown] = useState([]);
    const [rightsDropdown, setRightsDropdown] = useState([]);
    const [statusDropdown, setStatusDropdown] = useState([]);
    const [approvalLimitValue, setApprovalLimitValue] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();

    const selectorUsersId = useSelector((state) => state.usersSlc.value.id);
    const selectorUsersDrawerState = useSelector((state) => state.usersSlc.value.usersDrawerState);
    const selectorUsersDrawerMode = useSelector((state) => state.usersSlc.value.usersDrawerMode);
    const drawerModeRef = React.useRef(selectorUsersDrawerMode);
    // ****************** END STORE ****************************


    // ****************** BEGIN REGISTER ****************************

    const {register, handleSubmit} = useForm();

    // ****************** END REGISTER ****************************

    // Handle integer conversion on input change
    const handleApprovalLimitChange = (event) => {
        const { approvalLimitValue } = event.target;
        setApprovalLimitValue('approvalLimit', parseInt(approvalLimitValue, 10) || ''); // Converts input to integer, fallback to empty string if NaN
    };

    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        // setContractDataPointId(props.contractDataPointIdX)
        console.log("submitting")
        console.log("selectorUsersDrawerMode: ", selectorUsersDrawerMode)
        console.log("here's my Users data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorUsersDrawerMode==="Add"){
            addUsers(data)
                .then(() => {
                    console.log("Users added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeUsers({
                    id: null, dataPointId: null, productId: null,
                    usersStatus: null,
                    dataPointCode: null, dataPointName: null, dataType: null, dataPointStatus: null,
                    productCode:null, productName: null, category: null, productStatus: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    usersGridRefresh: true, usersDrawerState: false, usersDrawerMode: null}))
            })}
        if(selectorUsersDrawerMode==="Clone"){
            // data.id = null;
            // addUsers(data)
            const { id, ...clonedData } = data; // removes id
            addUsers(clonedData)
                .then(() => {
                    console.log("Users cloned");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record cloned"}));
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Clone failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeUsers({id: null, externalId: null, amount: null, displayAmount: null, availBegin: null,
                    availEnd: null, executionDate: null, userse: null, market: null, territory: null,
                    propertyId: null, exhibitionDays: null, runs: null,
                    createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
                    propertyName: null, initialMarket: null, genre: null, productionType: null,
                    usersGridRefresh: true, usersDrawerState: false, usersDrawerMode: null}))
            })}
        if(selectorUsersDrawerMode==="Edit"){
            console.log("This is the Users Id I am going to edit")
            console.log(selectorUsersId)
            editUsers(selectorUsersId, data)
                .then(() => {
                    console.log("Users edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err);
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                console.log("trigger refresh")
                dispatchData(changeUsers({
                    usersGridRefresh: true, usersDrawerState: false, usersDrawerMode: null}));
            })}
    };

    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };


    function closeUsersDrawer() {
        dispatchData(changeUsers({usersDrawerState: false }));
    };

    // ****************** END MISC ****************************


    // *********************** BEGIN DROPDOWNS **************************



const fetchDataPointValuesForDropdowns = () =>
    getAllDataPointValues()

        .then(data => {
            console.log(data);
            setDepartmentDropdown(data.filter(data => data.dataPointId ===  3714));
            setRoleDropdown(data.filter(data => data.dataPointId ===  3715));
            setRightsDropdown(data.filter(data => data.dataPointId ===  5746));
            setStatusDropdown(data.filter(data => data.dataPointId ===  3716));

        })
useEffect(() => {
    console.log("This is for the dropdown2...");
    fetchDataPointValuesForDropdowns();
}, []);
const renderDataPoints2 = dataPointValues => {
    if (dataPointValues.length <= 0) {
        return "No Data";
    }}


// *********************** END DROPDOWNS **************************

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    const fetchDataPoints = () =>
        getAllDataPoints()

            .then(data => {
                console.log(data);
                setDataPoints(data);
            })
    useEffect(() => {
        fetchDataPoints();
    }, []);



    // ****************** BEGIN FORM ****************************

    function usersForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 800, height: 300, pl: 5}}
                    role="presentation"
                >

                    <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeUsersDrawer()}>Users Form</h2>
                    <h4>{selectorUsersDrawerMode} Mode</h4>
                    <br/>
                    <br/>
                    <Input
                        style={{visibility: "hidden"}}
                        {...register('id', {required: true})}
                        id="id" name="id" label="id" aria-describedby="id_entry"
                        defaultValue={Number(useSelector((state) => state.usersSlc.value.id))}
                    />
                    <br/>
                    <br/>
                    <InputLabel htmlFor="firstName">First Name</InputLabel>
                    <Input
                        {...register('firstName', {required: true})}
                        id="firstName" name="firstName" label="firstName" aria-describedby="firstName_entry"
                        defaultValue={useSelector((state) => state.usersSlc.value.firstName)}
                        sx={{width: 600}}/>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="lastName">Last Name</InputLabel>
                    <Input
                        {...register('lastName', {required: true})}
                        id="lastName" name="lastName" label="lastName" aria-describedby="lastName_entry"
                        defaultValue={useSelector((state) => state.usersSlc.value.lastName)}
                        sx={{width: 600}}/>
                    <br/>
                    <br/>
                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="department">Department</InputLabel>
                        <Select

                            {...register('department', {required: true})}
                            labelId="department"
                            id="department"
                            label="department"
                            defaultValue={useSelector((state) => state.usersSlc.value.department)}
                            sx={{width: 300}}
                        >
                            {departmentDropdown.map((DepartmentItem) =>
                                <MenuItem value={DepartmentItem.name}>{DepartmentItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <br/>
                    <br/>
                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="role">Role</InputLabel>
                        <Select

                            {...register('role', {required: true})}
                            labelId="role"
                            id="role"
                            label="role"
                            defaultValue={useSelector((state) => state.usersSlc.value.role)}
                            sx={{width: 300}}
                        >
                            {roleDropdown.map((RoleItem) =>
                                <MenuItem value={RoleItem.name}>{RoleItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <br/>
                    <br/>
                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="rights">Rights</InputLabel>
                        <Select

                            {...register('rights', {required: true})}
                            labelId="rights"
                            id="rights"
                            label="rights"
                            defaultValue={useSelector((state) => state.usersSlc.value.rights)}
                            sx={{width: 300}}
                        >
                            {rightsDropdown.map((RightsItem) =>
                                <MenuItem value={RightsItem.name}>{RightsItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <br/>
                    <br/>
                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="status">Status</InputLabel>
                        <Select

                            {...register('status', {required: true})}
                            labelId="status"
                            id="status"
                            label="role"
                            defaultValue={useSelector((state) => state.usersSlc.value.status)}
                            sx={{width: 300}}
                        >
                            {statusDropdown.map((StatusItem) =>
                                <MenuItem value={StatusItem.name}>{StatusItem.name}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="approvalLimit">Approval Limit</InputLabel>
                    <Input
                        {...register('approvalLimit', {required: false})}
                        id="approvalLimit" name="approvalLimit" label="approvalLimit"
                        aria-describedby="approvalLimit_entry"
                        type="number"
                        onChange={handleApprovalLimitChange}
                        defaultValue={useSelector((state) => state.usersSlc.value.approvalLimit)}
                        sx={{width: 600}}/>
                    <br/>
                    <br/>
                    <InputLabel htmlFor="userName">User Name</InputLabel>
                    <Input
                        {...register('userName', {required: false})}
                        id="userName" name="userName" label="owner" aria-describedby="userName_entry"
                        defaultValue={useSelector((state) => state.usersSlc.value.userName)}
                        sx={{width: 600}}/>
                    <br/>
                    <br/>

                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeUsersDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );
    }

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
                <Input style={{ visibility: "hidden" }}
                       {...register('password', { required: false })}
                       id="password" name="password"  label="password" aria-describedby="password"
                       defaultValue=        {useSelector((state) => state.usersSlc.value.password)}
                />
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorUsersDrawerState}
                onClose={closeUsersDrawer}
            >
                {usersForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
